import { Icon, type IconProps } from "./icon";

/** Keys: an API key. */
export function KeysIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <g transform="rotate(-45 10 10)">
        <circle cx="6.25" cy="10" r="3.75" />
        <path d="M10 10h7.25M14.5 10v3M16.75 10v2" />
      </g>
    </Icon>
  );
}
